import React, { useEffect, useState } from 'react';
import Linechart from '../../components/LineChart/Linechart';
import StatCard from '../../components/StatCard/StatCard';
import { CiMoneyBill } from "react-icons/ci";
import { BsCreditCard } from "react-icons/bs";
import { HiUserPlus } from "react-icons/hi2";
import { FaBoxArchive } from "react-icons/fa6";
import axios from 'axios';
import { USER_URL } from '../../constant/api';
import { BsPersonFill } from 'react-icons/bs';

function SubAdminProfile() {
  const [dashboard, setDashboard] = useState({});
  const [profile, setProfile] = useState([]);
  const [chartdata, setChartData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          dashboardResponse,
          profileResponse,
          chartResponse,
        ] = await Promise.all([
          USER_URL.get(`/orders/subadmin/dashboard/`),
          USER_URL.get(`/accounts/subadmin/profile/`),
          USER_URL.get(`/orders/subadmin/revenue-sales/`),
        ]);

        setDashboard(dashboardResponse.data.data || {});
        setProfile(profileResponse.data.data || []);
        setChartData(chartResponse.data.Data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const statsData = [
    {
      title: 'Total Revenue',
      value: `₹${Math.floor(dashboard.revenue?.total_revenue) || '0'}`,
      change: `${dashboard.revenue?.revenue_percentage_change || '0'}`,
      bgColor: '#3250FF80',
      icon: <CiMoneyBill size={24} />,
      link: "/admin/revenueandincome",
    },
    {
      title: 'Total Orders',
      value: `${dashboard.orders?.total_orders || '0'}`,
      change: `${dashboard.orders?.order_percentage_change || '0'}`,
      bgColor: '#F9C80E80',
      icon: <BsCreditCard size={24} />,
      link: "/admin/orders/view_orders"
    },
    {
      title: 'Total Customers',
      value: `${dashboard.customers?.total_customers || '0'}`,
      change: `${dashboard.customers?.customer_percentage_change || '0'}`,
      bgColor: '#22CAAD80',
      icon: <HiUserPlus size={24} />,
      link: "/admin/customers"
    },
    {
      title: 'Total Products',
      value: `${dashboard.products?.total_products || '0'}`,
      change: `${dashboard.products?.product_percentage_change || '0'}`,
      bgColor: '#22CAAD80',
      icon: <FaBoxArchive size={24} />,
      link: "/admin/approval/products"
    },
    {
      title: "Today's Sales",
      value: `${dashboard.sales?.today_sales || '0'}`,
      change: `${dashboard.sales?.today_sales_percentage_change || '0'}`,
      bgColor: '#4E568380',
      icon: <BsCreditCard size={24} />,
      link: "/admin/sales"
    },
    {
      title: "Total Sales",
      value: `${dashboard.sales?.total_sales || '0'}`,
      change: `${dashboard.sales?.total_sales_percentage_change || '0'}`,
      bgColor: '#4D9D8F80',
      icon: <BsCreditCard size={24} />,
      link: "/admin/sales"
    },
    {
      title: "Total Stock",
      value: `${dashboard.stock?.total_stock || '0'}`,
      change: `${dashboard.stock?.stock_percentage_change || '0'}`,
      bgColor: '#1F295E80',
      icon: <BsCreditCard size={24} />,
      link: ""
    },
    {
      title: "New Products",
      value: `${dashboard.products?.new_products || '0'}`,
      change: `${dashboard.products?.new_products_percentage_change || '0'}`,
      bgColor: '#05BF0233',
      icon: <FaBoxArchive size={24} />,
      link: "/admin/approval/products"
    }
  ];

  return (
    <div className="space-y-8 p-4 min-h-screen bg-gray-50">
      {/* Profile Section */}
      <div className="flex items-center space-x-6 mb-8">
        <div className="w-24 h-24 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center">
          <BsPersonFill className="text-gray-500 text-7xl" />
        </div>
        <h2 className="text-3xl font-bold text-gray-800">
          {` ${profile.first_name}  ${profile.last_name}`}
        </h2>
      </div>

      {/* Personal Info Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">Personal Info</h2>
          <div className="space-y-4">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Name</span>
              <p className="text-lg font-semibold text-gray-800">{` ${profile.first_name}  ${profile.last_name}`}</p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Email</span>
              <p className="text-lg font-semibold text-gray-800">{profile.email}</p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Designation</span>
              <p className="text-lg font-semibold text-gray-800">{profile.designation}</p>
            </div>
          </div>
        </div>

        {/* Address Section */}
        <div>
          <div className="space-y-4 mt-12">
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Address</span>
              <p className="text-lg font-semibold text-gray-800">
                {` ${profile.address}`}
              </p>
            </div>
            <div className="p-4 bg-white border rounded-lg shadow-sm">
              <span className="block text-sm font-medium text-gray-600 mb-1">Location</span>
              <p className="text-lg font-semibold text-gray-800">
                {profile.location || "No secondary address available"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 ">
        {statsData.map((stat, index) => (
          <StatCard
            key={index}
            title={stat.title}
            value={stat.value}
            change={stat.change}
            bgColor={stat.bgColor}
            icon={stat.icon}
          />
        ))}
      </div>

      <div>
        <Linechart data={chartdata} />
      </div>
    </div>
  );
}

export default SubAdminProfile;
